<mat-card appearance="outlined">
    <mat-card-title [innerText]="'MAIN_APP_DIALOG.EMP_NOTE.title' | translate"></mat-card-title>
    <mat-card-content>
      <span class="row">
        <span style="word-break: break-word;  text-align: center;" [innerText]="data"></span>
      </span>
    </mat-card-content>
    <mat-dialog-actions>
      <button mat-stroked-button class="cancel" (click)="closeDialog()" [innerText]="'MAIN_APP_DIALOG.close' | translate"></button>
    </mat-dialog-actions>
  </mat-card>